import { render, staticRenderFns } from "./ButtonBorder.vue?vue&type=template&id=7ffbca5e&scoped=true&lang=pug&"
import script from "./ButtonBorder.vue?vue&type=script&lang=ts&"
export * from "./ButtonBorder.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonBorder.vue?vue&type=style&index=0&id=7ffbca5e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffbca5e",
  null
  
)

export default component.exports